import React, { useState, MouseEvent, ReactNode } from "react";
import { Menu, MenuItem } from "@mui/material";
import { ChevronDown } from "lucide-react";

interface MenuItemConfig {
  label: string;
  icon?: ReactNode;
  onClick: () => void;
}

interface SplitActionButtonProps {
  label: string;
  onClick: () => void;
  menuItems: MenuItemConfig[];
}

const SplitActionButton: React.FC<SplitActionButtonProps> = ({
  label,
  onClick,
  menuItems,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <div style={{ display: "flex", gap: 0 }}>
        <button
          className="btn-primary"
          onClick={onClick}
          style={{ borderRadius: "6px 0 0 6px" }}
        >
          {label}
        </button>
        <button
          className="btn-primary"
          onClick={(e: MouseEvent<HTMLButtonElement>) =>
            setAnchorEl(e.currentTarget)
          }
          style={{
            borderRadius: "0 6px 6px 0",
            borderLeft: "1px solid rgba(255,255,255,0.3)",
            padding: "8px",
            minWidth: "auto",
          }}
          aria-label="More actions"
        >
          <ChevronDown size={16} />
        </button>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {menuItems.map((item) => (
          <MenuItem
            key={item.label}
            onClick={() => {
              item.onClick();
              setAnchorEl(null);
            }}
          >
            {item.icon && (
              <span style={{ display: "flex", marginRight: 8 }}>
                {item.icon}
              </span>
            )}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default SplitActionButton;
